import { render } from "./StaticActionsModal.vue?vue&type=template&id=1ef768cc&ts=true"
import script from "./StaticActionsModal.vue?vue&type=script&lang=ts"
export * from "./StaticActionsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__